import * as React from "react";

import { ButtonFontWeight, ButtonSize, ButtonVariant, ButtonWidth } from "./Button";
import { Root, Text } from "./Button.sc";

interface StyledButtonSpanProps {
    size?: ButtonSize;
    variant?: ButtonVariant;
    width?: ButtonWidth;
    fontWeight?: ButtonFontWeight;
}

export const StyledButtonSpan: React.FunctionComponent<StyledButtonSpanProps> = ({
    children,
    size = ButtonSize.Default,
    variant = ButtonVariant.Default,
    width = ButtonWidth.Auto,
    fontWeight,
}) => {
    return (
        <Root size={size} variant={variant} width={width} as="span">
            <Text size={size} variant={variant} fontWeight={fontWeight}>
                {children}
            </Text>
        </Root>
    );
};
